(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ng-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      els.forEach(function (el) { el.classList.add('ng-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-ng-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('ng-visible');
            }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.01, rootMargin: '0px 0px 200px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initContadores() {
    var nums = document.querySelectorAll('[data-ng-contador]');
    if (!nums.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-ng-contador')) || 0;
      if (reduce) {
        el.textContent = fin;
        return;
      }
      var inicio = 0;
      var duracion = 1200;
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var progreso = Math.min((t - t0) / duracion, 1);
        var valor = Math.floor(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
        el.textContent = valor;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin;
      }
      requestAnimationFrame(paso);
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { observer.observe(el); });
  }

  function initCuentaAtras() {
    var el = document.querySelector('[data-ng-countdown-end]');
    if (!el) return;
    var texto = el.querySelector('[data-ng-countdown-texto]');
    if (!texto) return;
    var fin = new Date(el.getAttribute('data-ng-countdown-end')).getTime();
    var tick = function () {
      var restante = fin - Date.now();
      if (restante <= 0) {
        el.hidden = true;
        clearInterval(intervalo);
        return;
      }
      var h = Math.floor(restante / 3600000);
      var m = Math.floor((restante % 3600000) / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      texto.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    };
    var intervalo = setInterval(tick, 1000);
    tick();
  }

  function initModalDescuento() {
    var modal = document.querySelector('[data-ng-modal-descuento]');
    if (!modal) return;
    var cerrar = function () {
      modal.classList.remove('is-visible');
      setTimeout(function () { modal.hidden = true; }, 300);
    };
    var mostrado = false;
    var mostrar = function () {
      if (mostrado) return;
      mostrado = true;
      modal.hidden = false;
      setTimeout(function () { modal.classList.add('is-visible'); }, 10);
    };
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) {
        mostrar();
      }
    });
    var ultimoScrollY = window.scrollY;
    var subidaAcumulada = 0;
    window.addEventListener('scroll', function () {
      var actual = window.scrollY;
      if (actual < ultimoScrollY) {
        subidaAcumulada += (ultimoScrollY - actual);
        if (subidaAcumulada > 120 && actual < 400) {
          mostrar();
        }
      } else {
        subidaAcumulada = 0;
      }
      ultimoScrollY = actual;
    }, { passive: true });
    modal.querySelectorAll('[data-ng-modal-descuento-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrar);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrar();
    });
  }

  function initVerTodasResenas() {
    var boton = document.querySelector('[data-ng-ver-todas]');
    var grid = document.querySelector('[data-ng-resenas-grid]');
    if (!boton || !grid) return;
    boton.addEventListener('click', function () {
      var abierto = !grid.hidden;
      grid.hidden = abierto;
      boton.textContent = abierto ? 'Ver todas las opiniones' : 'Ocultar opiniones';
    });
  }

  function initFormsEmail() {
    document.querySelectorAll('form[data-ng-form-email]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('button[type="submit"]');
        var ok = form.parentNode.querySelector('[data-ng-form-email-ok]');
        if (boton) boton.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok || (r.url && r.url.indexOf('/challenge') !== -1)) { HTMLFormElement.prototype.submit.call(form); return; }
            form.hidden = true;
            if (ok) ok.hidden = false;
            try { localStorage.setItem('ng-email-' + form.getAttribute('data-ng-form-email'), '1'); } catch (_) {}
          })
          .catch(function () { HTMLFormElement.prototype.submit.call(form); });
      });
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll('[data-ng-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-ng-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-ng-galeria-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var tipo = mini.getAttribute('data-tipo');
          var src = mini.getAttribute('data-full');
          var videoSrc = mini.getAttribute('data-video');
          var alt = mini.getAttribute('data-alt') || '';
          var actual = principal.querySelector('img, video');

          if (tipo === 'video' && videoSrc) {
            if (actual && actual.tagName !== 'VIDEO') actual.remove();
            var video = principal.querySelector('video');
            if (!video) {
              video = document.createElement('video');
              video.setAttribute('playsinline', '');
              video.setAttribute('autoplay', '');
              video.setAttribute('muted', '');
              video.setAttribute('loop', '');
              video.setAttribute('controls', '');
              principal.appendChild(video);
            }
            video.setAttribute('src', videoSrc);
            video.setAttribute('aria-label', alt);
            video.muted = true;
            video.play();
          } else if (src) {
            if (actual && actual.tagName === 'VIDEO') actual.remove();
            var img = principal.querySelector('img');
            if (!img) {
              img = document.createElement('img');
              principal.appendChild(img);
            }
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('src', src);
            img.setAttribute('alt', alt);
          }

          minis.forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-ng-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-ng-variantes]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var inputId = form.querySelector('input[name="id"]');
      var botonesOpciones = form.querySelectorAll('[data-ng-opcion-valor]');
      var precioActual = form.querySelector('[data-ng-precio-actual]');
      var precioAntes = form.querySelector('[data-ng-precio-antes]');
      var botonComprar = form.querySelector('[data-ng-comprar]');
      var estadoTexto = form.querySelector('[data-ng-estado]');

      function opcionesSeleccionadas() {
        var seleccion = {};
        form.querySelectorAll('[data-ng-opcion]').forEach(function (grupo) {
          var activo = grupo.querySelector('.is-activo');
          if (activo) seleccion[grupo.getAttribute('data-ng-opcion')] = activo.getAttribute('data-ng-opcion-valor');
        });
        return seleccion;
      }

      function encontrarVariante() {
        var seleccion = opcionesSeleccionadas();
        return variantes.find(function (v) {
          return v.options.every(function (val, i) {
            var nombres = Object.keys(seleccion);
            return seleccion[nombres[i]] === undefined || seleccion[nombres[i]] === val;
          });
        });
      }

      function formatoDinero(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (inputId) inputId.value = variante.id;
        if (precioActual) precioActual.textContent = formatoDinero(variante.price);
        if (precioAntes) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAntes.textContent = formatoDinero(variante.compare_at_price);
            precioAntes.hidden = false;
          } else {
            precioAntes.hidden = true;
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !variante.available;
        }
        var botonYa = form.querySelector('[data-ng-comprar-ya]');
        if (botonYa) botonYa.disabled = !variante.available;
        if (estadoTexto) {
          if (!variante.available) {
            estadoTexto.textContent = estadoTexto.getAttribute('data-agotado') || 'Agotado';
            estadoTexto.classList.add('is-agotado');
          } else {
            estadoTexto.textContent = estadoTexto.getAttribute('data-disponible') || '';
            estadoTexto.classList.remove('is-agotado');
          }
        }
      }

      botonesOpciones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.closest('[data-ng-opcion]');
          grupo.querySelectorAll('[data-ng-opcion-valor]').forEach(function (b) { b.classList.remove('is-activo'); });
          btn.classList.add('is-activo');
          actualizar();
        });
      });

      actualizar();
    });
  }

  function initVideosPerezosos() {
    var videos = document.querySelectorAll('video[data-ng-video-lazy]');
    if (!videos.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var arrancar = function (v) {
      if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { videos.forEach(arrancar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) arrancar(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function (v) { io.observe(v); });
  }

  function initComprarYa() {
    document.querySelectorAll('[data-ng-comprar-ya]').forEach(function (boton) {
      var texto = boton.querySelector('[data-ng-comprar-ya-texto]');
      var textoOriginal = texto ? texto.textContent : '';
      boton.addEventListener('click', function () {
        var form = boton.closest('form');
        var inputId = form && form.querySelector('input[name="id"]');
        if (!inputId || boton.disabled) return;
        boton.disabled = true;
        if (texto) texto.textContent = 'Llevándote al pago…';
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: Number(inputId.value), quantity: 1 })
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            window.location.href = '/checkout?discount=NOGYMCLUB5';
          })
          .catch(function () { window.location.href = '/cart'; });
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          boton.disabled = false;
          if (texto) texto.textContent = textoOriginal;
        }
      });
    });
  }

  function initBarraFija() {
    var barra = document.querySelector('[data-ng-barra-fija]');
    var botonPrincipal = document.querySelector('[data-ng-comprar]');
    if (!barra || !botonPrincipal) return;
    var mostrada = false;
    var actualizar = function () {
      var rect = botonPrincipal.getBoundingClientRect();
      var debeMostrar = rect.bottom < 0 || rect.top > window.innerHeight;
      if (debeMostrar !== mostrada) {
        mostrada = debeMostrar;
        barra.hidden = false;
        barra.classList.toggle('is-visible', mostrada);
      }
    };
    window.addEventListener('scroll', actualizar, { passive: true });
    actualizar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initCuentaAtras();
    initModalDescuento();
    initVerTodasResenas();
    initFormsEmail();
    initGaleriaProducto();
    initVariantes();
    initComprarYa();
    initVideosPerezosos();
    initBarraFija();
  });
})();
